module.exports = __webpack_public_path__ + "img/driver-risk.ef453db3.png";